module.exports = "<captain-verification-page></captain-verification-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/captainVerificationView.html
// module id = 2254
// module chunks = 0